/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboard',
        title: 'Dashboard',
        type: 'basic',
        icon: 'feather:home',
        link: '/dashboard',
    },
    {
        id: 'customers',
        title: 'Customers',
        type: 'basic',
        icon: 'mat_outline:people',
        link: '/customer'
    },
    {
        id: 'transactions',
        title: 'Transactions',
        type: 'collapsable',
        icon: 'mat_outline:analytics',
        children: [
            {
                id: 'trx-listing',
                title: 'Transaction Listing',
                type: 'basic',
                icon: 'mat_solid:list',
                link: '/transaction-list',
            }
        ],
    },
    {
        id: 'product-services',
        title: 'Product Services',
        type: 'collapsable',
        icon: 'mat_solid:miscellaneous_services',
        badge: {
            title: null, // dynamically updated value
            classes: 'bg-white rounded-full text-primary p-1.5 ml-1 h-full w-auto aspect-square'
        },
        children: [
            {
                id: 'bill-management',
                title: 'Bill Management',
                type: 'collapsable',
                icon: 'mat_outline:receipt_long',
                children: [
                    {
                        id: 'bill-list',
                        title: 'Bill Category List',
                        type: 'basic',
                        icon: 'mat_outline:playlist_add',
                        link: '/bill/bill-list',
                    },
                    {
                        id: 'product-list',
                        title: 'Bill List',
                        type: 'basic',
                        icon: 'mat_solid:checklist',
                        link: '/bill/product-list',
                    },
                ]
            },
            {
                id: 'product-management',
                title: 'Product Management',
                type: 'collapsable',
                icon: 'mat_outline:production_quantity_limits',
                children: [
                    {
                        id: 'prepaid',
                        title: 'Prepaid',
                        type: 'basic',
                        icon: 'feather:smartphone',
                        link: '/prepaid',
                    },
                    {
                        id: 'postpaid',
                        title: 'Postpaid',
                        type: 'basic',
                        icon: 'mat_outline:phone_android',
                        link: '/postpaid',
                    },
                    {
                        id: 'electricity',
                        title: 'Electricity',
                        type: 'basic',
                        icon: 'mat_outline:bolt',
                        link: '/electricity', 
                    },
                    {
                        id: 'water',
                        title: 'Water',
                        type: 'basic',
                        icon: 'mat_outline:water_drop',
                        link: '/water',
                    },
                    {
                        id: 'gas',
                        title: 'Gas',
                        type: 'basic',
                        icon: 'mat_outline:local_drink',
                        link: '/gas',
                    },
                    {
                        id: 'music',
                        title: 'Music',
                        type: 'basic',
                        icon: 'mat_outline:library_music',
                        link: '/music',
                    },
                    {
                        id: 'stream-services',
                        title: 'Stream Services',
                        type: 'basic',
                        icon: 'mat_outline:smart_display',
                        link: '/stream-services',
                    },
                    {
                        id: 'game',
                        title: 'Game',
                        type: 'basic',
                        icon: 'mat_outline:videogame_asset',
                        link: '/game',
                    },
                    {
                        id: 'entertainment',
                        title: 'TV Channels',
                        type: 'basic',
                        icon: 'mat_solid:live_tv',
                        link: '/entertainment',
                    },
                    {
                        id: 'product-list',
                        title: 'Product List',
                        type: 'basic',
                        icon: 'mat_solid:checklist',
                        link: '/product-list',
                    }
                ]
            },
            {
                id: 'incomplete',
                title: 'Assign Plan/Category',
                type: 'collapsable',
                icon: 'feather:git-pull-request',
                badge: {
                    title: null, // dynamically updated value
                    classes: 'bg-white rounded-full text-primary p-1.5 ml-1 h-full w-auto aspect-square'
                },
                children: [
                    {
                        id: 'incomplete-product',
                        title: 'Product List',
                        type: 'basic',
                        icon: 'mat_solid:app_registration',
                        link: '/incomplete',
                        badge: {
                            title: null, // dynamically updated value
                            classes: 'bg-white rounded-full text-primary p-1.5 ml-1 h-full w-auto aspect-square'
                        }
                    },
                    {
                        id: 'incomplete-bill',
                        title: 'Bill List',
                        type: 'basic',
                        icon: 'mat_solid:app_registration',
                        link: '/bill/incomplete-list',
                        badge: {
                            title: null, // dynamically updated value
                            classes: 'bg-white rounded-full text-primary p-1.5 ml-1 h-full w-auto aspect-square'
                        }
                    },
                ]
            },
        ],
    },
    {
        id: 'wallet',
        title: 'Wallet Management',
        type: 'basic',
        icon: 'mat_outline:account_balance_wallet',
        link: '/wallet'
    },
];

